module.exports = __webpack_public_path__ + "img/trend.84653a91.svg";